import React, { Component } from "react";
import { connect } from "react-redux";
import {
  classCodesWatchOn,
  classCodesWatchOff
} from "../../actions/classCodesActions";
import Add from "./Add";
import Nav from "./Nav";
import Remove from "./Remove";

class ClassCodes extends Component {
  componentDidMount() {
    this.props.classCodesWatchOn();
  }

  componentWillUnmount() {
    this.props.classCodesWatchOff();
  }

  render() {
    const { showAdd } = this.props;
    return (
      <div className="row my-3">
        <div
          className="col-12 d-flex align-items-center"
          style={{ height: 50 }}
        >
          <Nav />
          {showAdd && <Add />}
          {showAdd && <Remove />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  session: state.session
});

export default connect(
  mapStateToProps,
  { classCodesWatchOn, classCodesWatchOff }
)(ClassCodes);
